import type { ApiErrorState, ApiErrorStateKind } from "./api";

export type ApiConnectionIssue = Pick<
  ApiErrorState,
  "description" | "kind" | "title" | "tone"
> & {
  detectedAt: number;
};

type ApiConnectionIssueListener = (issue?: ApiConnectionIssue) => void;

const connectionIssueKinds = new Set<ApiErrorStateKind>([
  "offline",
  "network",
  "timeout",
]);

const listeners = new Set<ApiConnectionIssueListener>();
let currentIssue: ApiConnectionIssue | undefined;

export function isApiConnectionIssueKind(kind?: ApiErrorStateKind) {
  return !!kind && connectionIssueKinds.has(kind);
}

export function getApiConnectionIssue() {
  return currentIssue;
}

export function subscribeApiConnectionIssue(
  listener: ApiConnectionIssueListener,
) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function reportApiConnectionIssue(
  issue: Pick<ApiConnectionIssue, "description" | "kind" | "title" | "tone">,
) {
  currentIssue = {
    ...issue,
    detectedAt: Date.now(),
  };

  listeners.forEach((listener) => listener(currentIssue));
}

export function clearApiConnectionIssue() {
  if (!currentIssue) {
    return;
  }

  currentIssue = undefined;
  listeners.forEach((listener) => listener(undefined));
}
